import { useRef, useEffect } from 'react';

const Gear = {
	Drive: 1,
	Neutral: 2,
	Reverse: 3,
};

const CyclicAction = {
	Stay: 0,
	Next: 1
};

const BinaryAction = {
	Skip: 0,
	Clear: 1,
    Flip: 2,
    Set: 3
};

function getBuffer(control) {
    let buffer = new ArrayBuffer(10 * 4 + 3); // 10x float of 4 bytes + 3 bytes

    let floats = new Float32Array(buffer, 0, 10);
    floats[0] = control.linearSpeed;
    floats[1] = control.angularSpeed;
    floats[2] = control.linearSpeedLimit;
    floats[3] = control.angularSpeedLimit;
    floats[4] = control.armUpDownSpeed;
    floats[5] = control.translationLeftRightSpeed;
    floats[6] = control.coverFlailUpDownSpeed;
    floats[7] = control.enlargementSpeed;
    floats[8] = control.engineSpeed;
    floats[9] = control.hydraulicAuxSpeed

    let ints = new Uint8Array(buffer, 10 * 4, 3);

    ints[0] =
        (control.ignition << 0) |
        (control.engine << 2) |
        (control.headlight << 4) |
        (control.neutralFlotting << 6) |
        (control.tool << 7);

    ints[1] =
        (control.electricAux << 0) |
        (control.increaseRPM << 2) |
        (control.decreaseRPM << 4) |
        (control.increaseLinearSpeed << 6);
        
    ints[2] =
        (control.decreaseLinearSpeed << 0) |
        (control.increaseAngularSpeed << 2) |
        (control.decreaseAngularSpeed << 4);

    console.log(control.increaselinearSpeed)

    return buffer;
}

export default function ControlStream ({ dataChannel, controlUpdateSetters, controlSendSetters, activityTimerRefresh }) {

    const controlRef = useRef({
        linearSpeed: 0.0,
        angularSpeed: 0.0,
        linearSpeedLimit: 0.0,
        angularSpeedLimit: 0.0,
        armUpDownSpeed: 0.0,
        translationLeftRightSpeed: 0.0,
        coverFlailUpDownSpeed: 0.0,
        enlargementSpeed: 0.0,
        engineSpeed: 0.0,
        hydraulicAuxSpeed: 0.0,

        ignition: BinaryAction.Skip,
        engine: BinaryAction.Skip,
        headlight: BinaryAction.Skip,
        neutralFlotting: false,
        tool: false,
        electricAux: BinaryAction.Skip,
        increaseRPM: BinaryAction.Skip,
        decreaseRPM: BinaryAction.Skip,
        increaselinearSpeed: BinaryAction.Skip,
        decreaseLinearSpeed: BinaryAction.Skip,
        increaseAngularSpeed: BinaryAction.Skip,
        decreaseAngularSpeed: BinaryAction.Skip

    });

    useEffect(() => {
        // Takes as only parameter a function that given as parameter the actual control will return the updated control.
        function controlUpdate (updateFunction) {
            controlRef.current = updateFunction(controlRef.current);
            activityTimerRefresh();
        }

        function controlSend () {
            const control = controlRef.current;

            // console.log(
            //     `Linear speed: ${control.linearSpeed}`.padEnd(30) +
            //     `, Brake: ${control.brake}`.padEnd(30) +
            //     `, Angular speed: ${control.angularSpeed}`.padEnd(40) +
            //     `, Gear: ${control.gear}`
            // );

            dataChannel.send(getBuffer(control)); // Every time the control changes send on network.

            // After each send reset the Binary Actions and Cyclic Action to the default values.
            controlRef.current = {
                ...control,
                cycleWheelMode: CyclicAction.Stay,
                cycleSpeedLimit: CyclicAction.Stay,
                engine: BinaryAction.Skip,
                electricAux: BinaryAction.Skip,
                ignition: BinaryAction.Skip,
                increaseRPM: BinaryAction.Skip,
                decreaseRPM: BinaryAction.Skip,
                increaseLinearSpeed: BinaryAction.Skip,
                decreaseLinearSpeed: BinaryAction.Skip,
                increaseAngularSpeed: BinaryAction.Skip,
                decreaseAngularSpeed: BinaryAction.Skip,
                leftTurningLight: BinaryAction.Skip,
                rightTurningLight: BinaryAction.Skip,
                headlight: BinaryAction.Skip,
                warningLights: BinaryAction.Skip,
            };
        }

        controlUpdateSetters.forEach((setControlUpdate) => {
            console.log('setting control update');
            setControlUpdate(() => controlUpdate); // need to wrap into a parameterless function to handle lazy initialization of useState
        });

        controlSendSetters.forEach((setControlSend) => {
            console.log('setting control send');
            setControlSend(() => controlSend); // need to wrap into a parameterless function to handle lazy initialization of useState
        });

        return () => {
            controlUpdateSetters.forEach((setControlUpdate) => {
                console.log('removing control update');
                setControlUpdate(null);
            });

            controlSendSetters.forEach((setControlSend) => {
                console.log('removing control send');
                setControlSend(null);
            });
        };
    }, [controlUpdateSetters, controlSendSetters, dataChannel, activityTimerRefresh]);

    useEffect(() => {
        dataChannel.onmessage = function (event) {
            console.error(`Control stream should not receive messages: ${event.data}`);
        }
    }, [dataChannel]);

    useEffect(() => {
        console.log('Mounting control stream');
        return () => {
            console.log('Unmount control stream');
        };
    }, []);

    return null;
}

export {
    Gear,
    CyclicAction,
    BinaryAction,
}
